export type PrimaryColors = keyof (typeof colors)["primary"];
export type SecondaryColors = keyof (typeof colors)["secondary"];

export type ColorNames =
  | `primary-${PrimaryColors}`
  | `secondary-${SecondaryColors}`;

export const colors = {
  "brand-red": "#ED1C24",
  "brand-red-2": "#B11116",
  "brand-blue": "#005E9E",
  primary: {
    red: {
      25: "#FFFBFB",
      50: "#FEF6F6",
      100: "#FDE7E8",
      200: "#FBCBCD",
      300: "#F8AAAD",
      400: "#F57B7F",
      500: "#ED1C24",
      600: "#D91118",
      700: "#BD0F15",
      800: "#A10D12",
      900: "#76090D",
      950: "#550709",
    },
    blue: {
      25: "#F5FBFF",
      50: "#EBF7FF",
      100: "#D1EDFF",
      200: "#9ED8FF",
      300: "#5CBEFF",
      400: "#0093F5",
      500: "#005E9E",
      600: "#00538A",
      700: "#00497A",
      800: "#003A61",
      900: "#002842",
      950: "#001C2E",
    },
  },
  neutral: {
    white: "#FFFFFF",
    grey: {
      25: "#FCFCFD",
      50: "#F9FAFB",
      100: "#F3F4F6",
      200: "#E5E7EB",
      300: "#D2D5DA",
      400: "#BEC3CC",
      500: "#9CA3AF",
      600: "#717684",
      700: "#4B5563",
      800: "#374254",
      900: "#1C2633",
      950: "#0C111D",
    },
  },
  secondary: {
    red: {
      25: "#fef8f8",
      50: "#fef1f1",
      100: "#fde8e7",
      200: "#fbcdcb",
      300: "#f9adaa",
      400: "#f5837f",
      500: "#f03e38",
      600: "#e81811",
      700: "#cc150f",
      800: "#a6110c",
      900: "#800e0a",
      950: "#510906",
    },
    blue: {
      25: "#F4F8FE",
      50: "#E5EFFF",
      100: "#D9E7FF",
      200: "#C2D9FF",
      300: "#99C0FF",
      400: "#6BA4FF",
      500: "#3884FF",
      600: "#186CF2",
      700: "#0057E5",
      800: "#0048BE",
      900: "#00358C",
      950: "#002258",
    },
    lightblue: {
      25: "#f8fdff",
      50: "#f1fbfe",
      100: "#def5fc",
      200: "#bdeaf9",
      300: "#93ddf6",
      400: "#69d0f2",
      500: "#2bbbed",
      600: "#13aadd",
      700: "#1095c1",
      800: "#0e7ba0",
      900: "#0a5771",
      950: "#073e50",
    },
    indigo: {
      25: "#f9fbfd",
      50: "#f4f6fb",
      100: "#e6ebf5",
      200: "#c9d3e9",
      300: "#a4b6da",
      400: "#7590c7",
      500: "#3a568f",
      600: "#354f83",
      700: "#2e4470",
      800: "#25375b",
      900: "#1a2741",
      950: "#121a2c",
    },
    brown: {
      25: "#fef6f5",
      50: "#fcecea",
      100: "#fad9d5",
      200: "#f7c7c0",
      300: "#f5b4ab",
      400: "#f2a196",
      500: "#d3857a",
      600: "#b4695e",
      700: "#944c43",
      800: "#763d36",
      900: "#592e28",
      950: "#3b1e1b",
    },
    purple: {
      25: "#fbf8ff",
      50: "#f6f1fe",
      100: "#f0e8fd",
      200: "#deccfa",
      300: "#c8acf6",
      400: "#ad82f2",
      500: "#8242eb",
      600: "#772fe9",
      700: "#6518e2",
      800: "#5514bd",
      900: "#3c0e86",
      950: "#21084a",
    },
    yellow: {
      25: "#fffdf7",
      50: "#fffbf0",
      100: "#fef4d7",
      200: "#fce9b0",
      300: "#fbdc7f",
      400: "#f9ce4d",
      500: "#f7bc0a",
      600: "#e3ac07",
      700: "#c69606",
      800: "#a37c05",
      900: "#775a04",
      950: "#594303",
    },
    green: {
      25: "#f6fef9",
      50: "#eafaf0",
      100: "#d9f7e6",
      200: "#abf2cf",
      300: "#70e0a8",
      400: "#3ecd91",
      500: "#27b077",
      600: "#0e8c58",
      700: "#067848",
      800: "#08613c",
      900: "#084d30",
      950: "#03331f",
    },
    orange: {
      25: "#fffcf5",
      50: "#fff6e0",
      100: "#feeec7",
      200: "#fddb89",
      300: "#fec24b",
      400: "#fda922",
      500: "#f78409",
      600: "#dc5d03",
      700: "#b53f08",
      800: "#93310d",
      900: "#7a290e",
      950: "#4e1a09",
    },
  },
};
